import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';

export default function CategoriesForm({ category, onSubmit, resetCurrentCategory }) {
    const { register, handleSubmit, formState: { errors }, reset } = useForm({
        defaultValues: category || {}
    });

    useEffect(() => {
        reset(category);
    }, [category, reset]);

    const handleCancelEdit = () => {
        resetCurrentCategory()
        reset({ categoryRoute: '', categoryName: '' });
    }


    const submitHandler = async (data) => {
        try {
            await onSubmit(data);
            console.log(data)
            handleCancelEdit()
        } catch (error) {
            console.error("Ошибка при отправке данных:", error);
        }
    };

    return (
        <>
            {category &&
                <div className="manager__cancel">
                    <p>Идет редактирование</p>
                    <button className='manager__button' onClick={handleCancelEdit}>Отмена</button>
                </div>
            }

            <form onSubmit={handleSubmit(submitHandler)}>
                <div className="form__item">
                    <label htmlFor="categoryName">Название</label>
                    <div>
                        <input
                            id="categoryName"
                            {...register("categoryName", { required: "Это поле обязательно" })}
                        />
                        {errors.categoryName && <span>{errors.categoryName.message}</span>}
                    </div>
                </div>
                <div className="form__item">
                    <label htmlFor="categoryRoute">Маршрут (название на английком, с строчной буквы)</label>
                    <div>
                        <input
                            id="categoryRoute"
                            {...register("categoryRoute", { required: "Это поле обязательно" })}
                        />
                        {errors.categoryRoute && <span>{errors.categoryRoute.message}</span>}

                    </div>
                </div>
                <button type="submit">Сохранить</button>
            </form>
        </>
    );
}
